import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/InfoPages.css';

const About = () => {
  return (
    <div className="info-page-container">
      <div className="info-page">
        <h1>About Artifex</h1>

        <p>Artifex is a curated platform for discovering and exploring exceptional design, architecture, culture, and craft. Our mission is to create a thoughtfully edited space where quality, context, and aesthetic integrity take precedence over virality and algorithmic noise.</p>

        <p>Founded in 2025, Artifex serves architects, designers, collectors, and culturally curious individuals who value curation over chaos. We combine editorial storytelling, cultural discovery, and carefully selected products to create an experience that elevates how you encounter design in the world.</p>

        <h2>Our Platform</h2>
        <p>Artifex is organized into five interconnected sections:</p>
        <ul>
          <li><strong>Discover</strong>: A visually rich feed showcasing architecture, interiors, art, and objects sourced from museums, cultural institutions, and vetted contributors.</li>
          <li><strong>Guides</strong>: Curated location-based guides featuring restaurants, shops, and cultural destinations worth experiencing.</li>
          <li><strong>Editorials</strong>: Original essays, interviews, and editorial features exploring design, culture, and craft through thoughtful storytelling.</li>
          <li><strong>Signals</strong>: A feed of inspirational moments, brand partnerships, and cultural observations that capture the spirit of contemporary design.</li>
          <li><strong>Shop</strong>: A carefully selected collection of exceptional design objects, tools, and products that embody quality and craftsmanship.</li>
          <li><strong>Digital Cards</strong>: Personalized aesthetic profiles that represent your unique sensibilities and help filter content to match your preferences.</li>
        </ul>

        <p>We believe in quality over quantity, design integrity over virality, and meaningful discovery over mindless scrolling. Artifex is built for those who appreciate the intentionality of curation and the value of context.</p>
        
        <div className="info-links">
          <Link to="/help">Help</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
        </div>
      </div>
    </div>
  );
};

export default About;